import React, { useCallback } from "react";
import { Metadata } from "GraphQL/Queries/Metadata/GetMetadata";
import { configs } from "configs";
import { Layout, RowGroup, RowTitle } from "../formStyle";
import defaultImage from "assets/images/cover.png";
import { useHistory } from "react-router";
import { WORKS } from "constants/route";

type Props = {
  work: Metadata[];
  searchQuery: string;
};

export const WorkForm = ({ work, searchQuery }: Props) => {
  const router = useHistory();
  const onMovePage = useCallback(() => router.push(`${WORKS}?page=1${!searchQuery ? "" : `&title=${searchQuery}`}`), [router, searchQuery]);
  const onMoveById = useCallback((id: string) => router.push(`${WORKS}?page=1&id=${id}`), [router]);

  return (
    <Layout>
      <RowTitle>
        <span>작품</span>
        <button onClick={onMovePage}>{"＞"}</button>
      </RowTitle>
      {!work.length ? (
        <div className="no-data">해당 작품이 없습니다.</div>
      ) : (
        work.map(({ metadataId, title, artistRelation, metadataUrl }) => {
          const cover = metadataUrl?.filter(({ typeUrl }) => typeUrl === "cover" || typeUrl === "thumbnail" || typeUrl === "head")[0]?.url;
          return (
            <RowGroup key={metadataId} onClick={() => onMoveById(metadataId)}>
              <div className="thumb">
                <img src={cover ? `${configs.urls.image}/${cover}?mode=s` : defaultImage} alt={title} />
              </div>
              <div className="info_area">
                <div className="title">
                  <span>{title}</span>
                </div>
                <div className="artist">
                  <span>{artistRelation[0]?.artist[0].name ?? "-"}</span>
                </div>
              </div>
            </RowGroup>
          );
        })
      )}
    </Layout>
  );
};
